import { motion, AnimatePresence } from 'framer-motion';
import { X, LayoutDashboard } from 'lucide-react';

interface OverviewInAppModalProps {
  isOpen: boolean;
  onClose: () => void;
}

export default function OverviewInAppModal({ isOpen, onClose }: OverviewInAppModalProps) {
  if (!isOpen) return null;
  return (
    <AnimatePresence>
      {isOpen && (
        <div className="fixed inset-0 bg-black/80 backdrop-blur-sm z-50 flex items-center justify-center p-4 overflow-y-auto">
          <motion.div
            initial={{ opacity: 0, scale: 0.95 }}
            animate={{ opacity: 1, scale: 1 }}
            exit={{ opacity: 0, scale: 0.95 }}
            className="bg-gradient-to-br from-slate-900 via-cyan-900 to-slate-900 rounded-2xl max-w-5xl w-full my-8 border border-cyan-500/30 shadow-2xl shadow-cyan-500/20"
          >
            <div className="relative p-8 border-b border-cyan-500/30">
              <div className="flex items-start justify-between">
                <div className="flex items-center gap-4">
                  <div className="p-3 bg-gradient-to-br from-cyan-500 to-blue-500 rounded-xl">
                    <LayoutDashboard className="w-10 h-10 text-white" />
                  </div>
                  <div>
                    <h2 className="text-4xl font-bold text-transparent bg-clip-text bg-gradient-to-r from-cyan-400 to-blue-400">
                      Overview In-App
                    </h2>
                    <p className="text-gray-400 mt-1 text-lg">Obligatoire dans chaque application - 100% apps</p>
                  </div>
                </div>
                <button onClick={onClose} className="p-2 hover:bg-white/10 rounded-lg transition-colors">
                  <X className="w-6 h-6 text-gray-400" />
                </button>
              </div>
            </div>
            <div className="p-8 space-y-8 max-h-[calc(100vh-300px)] overflow-y-auto">
              <div className="bg-gradient-to-r from-cyan-600/20 via-blue-600/20 to-cyan-600/20 rounded-xl p-8 border-2 border-cyan-500/50">
                <h3 className="text-2xl font-bold text-center text-white mb-4">Overview In-App Obligatoire</h3>
                <p className="text-gray-300 text-center text-lg">
                  ROI/KPI, Sécurité NIST-style, IA/Éthique, README, Roadmap. Visible dans chaque application.
                </p>
              </div>
              <div className="grid md:grid-cols-2 gap-4">
                <div className="bg-slate-800/50 rounded-lg p-4">
                  <h5 className="text-cyan-400 font-bold mb-2">ROI/KPI</h5>
                  <p className="text-gray-300 text-sm">Métriques de retour sur investissement et indicateurs clés de performance.</p>
                </div>
                <div className="bg-slate-800/50 rounded-lg p-4">
                  <h5 className="text-blue-400 font-bold mb-2">Sécurité NIST-style</h5>
                  <p className="text-gray-300 text-sm">Posture de sécurité documentée selon les standards NIST.</p>
                </div>
                <div className="bg-slate-800/50 rounded-lg p-4">
                  <h5 className="text-cyan-400 font-bold mb-2">IA/Éthique</h5>
                  <p className="text-gray-300 text-sm">Utilisation de l'IA et considérations éthiques.</p>
                </div>
                <div className="bg-slate-800/50 rounded-lg p-4">
                  <h5 className="text-blue-400 font-bold mb-2">README & Roadmap</h5>
                  <p className="text-gray-300 text-sm">Documentation et planification du projet.</p>
                </div>
              </div>
            </div>
            <div className="p-6 border-t border-cyan-500/30 bg-slate-900/50">
              <div className="flex items-center justify-end">
                <button onClick={onClose} className="px-6 py-3 bg-gradient-to-r from-cyan-500 to-blue-500 text-white rounded-xl hover:from-cyan-600 hover:to-blue-600 transition-all duration-200 font-semibold shadow-lg shadow-cyan-500/20 hover:shadow-cyan-500/40 hover:scale-105">
                  Fermer
                </button>
              </div>
            </div>
          </motion.div>
        </div>
      )}
    </AnimatePresence>
  );
}

